import { chartColors } from "./chartTheme";

/**
 * Draws each value centred inside its own bar segment.
 * Configure per chart via `options.plugins.valueLabels`:
 *   { suffix: "%", minHeight: 14, color: "#fff" }
 * Segments shorter than `minHeight` are skipped so labels never overflow.
 */
export const valueLabelsPlugin = {
  id: "valueLabels",
  defaults: { suffix: "", minHeight: 14, color: null },
  afterDatasetsDraw(chart, _args, opts) {
    const { suffix = "", minHeight = 14 } = opts || {};
    const color = opts?.color || chartColors().onDark;
    const { ctx } = chart;

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      if (meta.hidden) return;

      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        if (!value) return; // skip zero / empty segments
        if (Math.abs(bar.base - bar.y) < minHeight) return;

        ctx.save();
        ctx.fillStyle = color;
        ctx.font = "600 12px -apple-system,BlinkMacSystemFont,sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(`${value}${suffix}`, bar.x, (bar.y + bar.base) / 2);
        ctx.restore();
      });
    });
  },
};

export default valueLabelsPlugin;
